import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useEffect, useState } from "react"
import {
  CardBody,
  Card,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
} from "reactstrap"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { AvForm, AvField } from "availity-reactstrap-validation"
import classnames from "classnames"
import { isMobile } from "react-device-detect"

import LoginLapImag from "../../assets/images/Login PC.png"
import LoginMobImag from "../../assets/images/Login PC.png"

import { 
  loginUser, 
  apiError, 
  socialLogin,
  clearLoginMessage
} from "../../store/actions"
// import {CustomPopup} from "../CustomPopup/popup" // Import the custom popup component

const CustomPopup = ({ show, onClose, title, message, type = "error" }) => {
  if (!show) return null

  const getIcon = () => {
    switch (type) {
      case "success":
        return (
          <svg className="popup-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        )
      case "error":
        return (
          <svg className="popup-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        )
      case "warning":
        return (
          <svg className="popup-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        )
      default:
        return null
    }
  }

  return (
    <div className="popup-overlay">
      <div className={`popup-container popup-${type}`}>
        <div className="popup-header">
          {getIcon()}
          <h3 className="popup-title">{title}</h3>
        </div>
        <div className="popup-body">
          <p className="popup-message">{message}</p>
        </div>
        <div className="popup-footer">
          <button className="popup-btn" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
      <style>{`
        .popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .popup-container {
          // background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          background-image: url('https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/SEES%20-%20constellation%20of%20us%2FLogin%20Laptop.png?alt=media&token=7f3c1a16-fc63-42bf-ac6c-b5c7b33e8346');
          background-size: contain;
          border-radius: 20px;
          padding: 30px;
          max-width: 400px;
          width: 90%;
          box-shadow: 0 0 30px rgba(255, 255, 255, 0.3);
          animation: slideUp 0.3s ease;
          border: 2px solid rgba(255, 255, 255, 0.5);
        }

        @keyframes slideUp {
          from {
            transform: translateY(50px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }


        .popup-success {
          // background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
        }

        .popup-error {
          // background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
        }

        .popup-warning {
          // background: linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%);
        }

        .popup-header {
          text-align: center;
          margin-bottom: 20px;
        }

        .popup-icon {
          width: 60px;
          height: 60px;
          margin: 0 auto 15px;
          color: white;
          stroke-width: 2;
        }

        .popup-title {
          color: white;
          font-size: 24px;
          font-weight: bold;
          margin: 0;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }

        .popup-body {
          margin-bottom: 25px;
        }

        .popup-message {
          color: white;
          font-size: 16px;
          line-height: 1.6;
          text-align: center;
          margin: 0;
        }

        .popup-footer {
          text-align: center;
        }

        .popup-btn {
          background: white;
          color: #173356;
          border: none;
          padding: 12px 40px;
          border-radius: 25px;
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
        }

        .popup-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
        }

        .popup-btn:active {
          transform: translateY(0);
        }
      `}</style>
    </div>
  )
}

const Login = props => {
  const [modalState, setModalState] = useState(false)
  const [activeTab, setActiveTab] = useState("Individual")
  const [activeTabContent, setActiveTabContent] = useState("1")
  const [showPassword, setShowPassword] = useState(false)
  const [alertVisible, setAlertVisible] = useState(true)
  const [messageToken, setMessageToken] = useState("")
  const [helprc, onhelpOpenRC] = useState(false)
  const [toggleMessage, setToggleMessage] = useState("")
  var tawklink = ""
  const [iloader, setILoader] = useState(false)
  const [isRefreshing, setIsRefreshing] = useState(false)
  const [currentAction, setCurrentAction] = useState("Login")

  // Custom Popup State
  const [popup, setPopup] = useState({
    show: false,
    title: "",
    message: "",
    type: "error"
  })

  const [formData, setFormData] = useState({
    Email: "",
    otp: "",
    Token: messageToken,
  })

  // Custom Popup Functions
  const showPopup = (title, message, type = "error") => {
    setPopup({ show: true, title, message, type })
  }

  const closePopup = () => {
    setPopup({ ...popup, show: false })
    // Clear the message from Redux to prevent re-showing
    if (props.clearLoginMessage) {
      props.clearLoginMessage()
    }
  }

  // Check for errors from props and show popup
  useEffect(() => {
  const mssg = props.mssg   // Get message from props

  if (mssg) {
    let title, type, message  // DECLARE variables with let

    // Handle old/general errors
    if (mssg === "Email is not Official!") {
      title = "Invalid Email Domain"
      type = "error"
      message = "Please use your official email address to login."
    } else if (mssg === "OTP sent successfully to your email") {
      title = "Success!"
      type = "success"
      message = "OTP has been sent to your email. Please check your inbox."
    } else if (mssg === "User Verified") {
      title = "Verified!"
      type = "success"
      message = "You have been successfully verified. Redirecting..."
    } else if (mssg === "Entered OTP failed to match. Please try again with latest OTP.") {
      title = "Invalid OTP"
      type = "error"
      message = "The OTP you entered is incorrect. Please try again."
    } else if (mssg === "Please Generate OTP first to login") {
      title = "OTP Required"
      type = "warning"
      message = "Please generate an OTP first before attempting to login."
    } else if (mssg === "Something went wrong, Please try again!") {
      title = "Error"
      type = "error"
      message = "Something went wrong. Please try again later."
    } else {
      // Default error handler
      title = "Notification"
      type = "error"
      message = mssg
    }

    showPopup(title, message, type)

    // Always clean up loaders
    setIsRefreshing(false)
    setILoader(false)
  }
}, [props.mssg])   // ← This is the magic line

  useEffect(() => {
    const storedToken = localStorage.getItem("notificationToken") || ""
    setMessageToken(storedToken)
    setFormData(prev => ({ ...prev, Token: storedToken }))
  }, [])

  useEffect(() => {
    try {
      const storedData = localStorage.getItem("otpFormData")
      if (storedData) {
        const parsedData = JSON.parse(storedData)
        console.log("Restoring form data on component mount:", parsedData)

        setFormData(prevData => ({
          ...prevData,
          Email: parsedData.Email || prevData.Email,
          Token: parsedData.Token || prevData.Token,
        }))
      }
    } catch (error) {
      console.error("Error restoring form data on mount:", error)
    }
  }, [])

  useEffect(() => {
    setFormData(prev => ({ ...prev, Token: messageToken }))
  }, [messageToken])

  useEffect(() => {
    const loader = document.querySelector(".loader")
    if (loader) {
      loader.classList.add("loader--hide")
    }
    setMessageToken(localStorage.getItem("notificationToken"))
  }, [])

  const toggle1 = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  const Alldata = JSON.parse(localStorage.getItem("dataJ"))

  const toggleModal = () => setModalState(!modalState)
  const togglePasswordVisibility = () => setShowPassword(!showPassword)
  const hideAlert = () => setAlertVisible(false)

  const handleValidSubmit = (event, values) => {
    event.preventDefault()

    setFormData({
      Email: values.Email || formData.Email,
      otp: values.otp || formData.otp,
      Token: values.Token || formData.Token,
    })

    const updatedValues = {
      ...values,
      customaction: currentAction,
    }

    props.loginUser(updatedValues, props.history)
  }

  const handleButtonClick = (action, event) => {
    event.preventDefault()
    event.stopPropagation()

    setCurrentAction(action)

    const currentFormState = { ...formData }
    const form = event.target.closest("form")
    const formElements = form.elements

    const currentValues = {
      Email: formElements.Email?.value || currentFormState.Email || "",
      otp: formElements.otp?.value || currentFormState.otp || "",
      Token:
        formElements.Token?.value ||
        currentFormState.Token ||
        messageToken ||
        "",
      customaction: action,
    }

    console.log(currentValues)

    if (action === "generate") {
      const formDataToStore = {
        Email: currentValues.Email,
      }

      try {
        localStorage.setItem("otpFormData", JSON.stringify(formDataToStore))
        console.log("Form data stored in localStorage:", formDataToStore)
        
        setIsRefreshing(true)
        setILoader(true)
        
        props.loginUser(currentValues, props.history)
        
        return
      } catch (error) {
        console.error("Error storing form data in localStorage:", error)
        setIsRefreshing(false)
        setILoader(false)
      }
    }

    setILoader(true)
    props.loginUser(currentValues, props.history)

    setTimeout(() => {
      setFormData({
        Email: currentValues.Email,
        otp: currentValues.otp,
        Token: currentValues.Token,
      })
    }, 1000)
  }

  const handleTabToggle = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }
  const handleToggleMessage = event => setToggleMessage(event.target.value)

  return (
    <React.Fragment>
      <MetaTags>
        <title>Constellation Of Us</title>
      </MetaTags>

      {/* Custom Popup Component */}
      <CustomPopup
        show={popup.show}
        onClose={closePopup}
        title={popup.title}
        message={popup.message}
        type={popup.type}
      />

      {/* Debug helper - remove later */}
{/* <div style={{
  position: 'fixed',
  top: '20px',
  left: '20px',
  background: popup.show ? '#00cc00' : '#ff4444',
  color: 'white',
  padding: '12px 20px',
  borderRadius: '8px',
  zIndex: 100000,
  fontWeight: 'bold'
}}>
  Popup is {popup.show ? 'VISIBLE' : 'HIDDEN'} • Last message: {props.mssg || '(none)'}
</div> */}

      <Modal
        size="xl"
        isOpen={modalState}
        toggle={toggleModal}
        centered
        style={{ width: "auto" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Photo Mosaic</h5>
          <button
            type="button"
            onClick={toggleModal}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <iframe
            allow="camera; microphone"
            title="test"
            className="embed-responsive-item mosaic"
            src={encodeURI("https://demo-mosaic.herokuapp.com/")}
          />
        </div>
      </Modal>

      <Modal
        isOpen={helprc}
        toggle={() => {
          onhelpOpenRC(!helprc)
        }}
        centered={true}
        style={{ width: "auto" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Help Desk</h5>
          <button
            type="button"
            onClick={() => {
              onhelpOpenRC(!helprc)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {Alldata?.data?.lobby?.data?.areas?.map((item, i) =>
            (() => {
              switch (item.id) {
                case "help": {
                  return <div key={i}>
                    {item.url ? (tawklink = item.url) : (tawklink = "")}
                  </div>
                }
                default:
                  return null
              }
            })()
          )}
          <iframe
            height="450px"
            width="100%"
            title="test"
            className="embed-responsive-item"
            src={encodeURI(tawklink)}
          />
        </div>
      </Modal>

      <Container fluid style={{ padding: 0, position: "relative" }}>
        <img
          loading="lazy"
          src={
            isMobile
              ? // LoginMobImag
              "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/SEES%20-%20constellation%20of%20us%2FLogin%20Phone.png?alt=media&token=175180ce-5af8-42b3-af57-a4b832369438"
              : "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/SEES%20-%20constellation%20of%20us%2FLogin%20Laptop.png?alt=media&token=7f3c1a16-fc63-42bf-ac6c-b5c7b33e8346"
              // LoginLapImag
            }
          style={{ position: "absolute", width: "100%", height: "100vh" }}
          alt="Login"
        />

        <div className="account-pages pt-sm-5 d-flex justify-content-center align-items-center">
          <div className="loginLogo" style={{ width: "60%", textAlign: "center", backgroundColor: "transparent",  zIndex: "1"  }}>
            <img loading="lazy"
              src="https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/SEES%20-%20constellation%20of%20us%2FLogo.png?alt=media&token=ae326eb7-aa2b-4253-8efb-f017694de370"
              style={{  marginTop: "10%", width: "60%", color: "white" }}
              alt="SEES Logo"
            />
          </div>
          <center className="loginCenter">
            <Card
              className="overflow-hidden cardLogin"
              style={{
                boxShadow: "none",
                background: "rgba(0, 0, 0, 0.0)",
              }}
            >
              <CardBody className="pt-0" style={{ padding: 0 }}>
                <div className="p-2" style={{ color: "#fff" }}>
                  <Nav
                    style={{ columnGap: "2%" }}
                    pills
                    className="navtab-bg nav-justified"
                  >
                    <NavItem>
                       {/* <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "Individual",
                        })}
                        onClick={() => {
                          toggle1("Individual")
                          setActiveTabContent("1")
                        }}
                      >
                        Login
                      </NavLink> */}
                      <div id="1"></div>
                    </NavItem>
                    {/* <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "Team",
                        })}
                        onClick={() => {
                          toggle1("Team")
                          setActiveTabContent("2")
                        }}
                      >
                        Register
                      </NavLink>
                    </NavItem> */}
                  </Nav>

                  <TabContent
                    activeTab={activeTabContent}
                    className="p-3 text-muted"
                  >
                    <TabPane tabId="1">
                      <AvForm
                        className="form-horizontal"
                        onValidSubmit={handleValidSubmit}
                      >
                        {/* <div className="mb-1">
                          <AvField
                            name="Firstname"
                            className="form-control"
                            placeholder="Name *"
                            type="text"
                            required
                          />
                        </div> */}
                        <div className="mb-1">
                          <AvField
                            name="Email"
                            className="form-control"
                            placeholder="Enter Your PRI Email ID*"
                            type="email"
                            value={formData.Email}
                            onChange={e =>
                              setFormData({
                                ...formData,
                                Email: e.target.value,
                              })
                            }
                            required
                            style={{
                              background: "linear-gradient(to bottom, transparent 30%, rgba(0, 0, 0, 0.5))",
                              color: "white !important",
                              border: "0px solid transparent",
                              borderBottom: "2px solid white",
                              borderRadius: "0px",
                              borderBottomLeftRadius : "20px",
                              borderBottomRightRadius : "20px",
                              fontWeight: "bold",
                              fontSize: "0.9rem",
                              letterSpacing: "2px",
                              paddingLeft: "20px",
                            }}
                          />
                        </div>

                        <div className="mb-1">
                          <AvField
                            name="otp"
                            className="form-control"
                            placeholder="OTP*"
                            type="text"
                            value={formData.otp}
                            onChange={e =>
                              setFormData({ ...formData, otp: e.target.value })
                            }
                            required
                            style={{
                              background: "linear-gradient(to bottom, transparent 30%, rgba(0, 0, 0, 0.5))",
                              color: "white !important",
                              border: "0px solid transparent",
                              borderBottom: "2px solid white",
                              borderRadius: "0px",
                              borderBottomLeftRadius : "20px",
                              borderBottomRightRadius : "20px",
                              fontWeight: "bold",
                              fontSize: "0.9rem",
                              letterSpacing: "2px",
                              paddingLeft: "20px",
                              width: "80%",
                            }}
                          />
                        </div>

                        {/* <div className="mb-1">
                          <AvField
                            name="EmployeeID"
                            className="form-control"
                            placeholder="Employee Code *"
                            type="text"
                            required
                          />
                        </div> */}

                        <div className="mb-3">
                          <AvField
                            name="Token"
                            value={formData.Token}
                            onChange={e =>
                              setFormData({
                                ...formData,
                                Token: e.target.value,
                              })
                            }
                            className="form-control newgrad"
                            placeholder="token"
                            type="text"
                            hidden
                          />
                        </div>

                        <div className="mb-3">
                          <AvField
                            name="customaction"
                            value={currentAction}
                            className="form-control newgrad"
                            placeholder="action *"
                            type="text"
                            required
                            disabled
                            hidden
                          />
                        </div>

                        <div
                          className="mt-3 d-flex justify-content-evenly"
                          style={{ textAlign: "center", display:"flex", justifyContent: "space-between", rowGap:"10px" }}
                        >
                           {/* <button
                            style={{
                              outline: "none",
                              border: "none",
                            }}
                            className="btn btn-primary btn-block applebtn"
                            type="submit"
                          >
                            Login
                          </button> */}

                          <div className="Btncontainer">
                            <button 
                              type="button" 
                              className="Btnbutton" 
                              disabled={iloader || isRefreshing} 
                              onClick={e => handleButtonClick("generate", e)}
                            >
                              <div className="Btnstar"></div>
                              <div className="Btnstar s2"></div>
                              <div className="Btnstar s3"></div>
                              <span>{iloader || isRefreshing ? "Sending OTP..." : "Send OTP"}</span>
                              {/* <div className="Btnmoon"></div> */}
                            </button>
                          </div>

                          <div className="Btncontainer">
                            <button 
                              type="button" 
                              className="Btnbutton" 
                              disabled={iloader}
                              onClick={e => handleButtonClick("verify", e)}
                            >
                              <div className="Btnstar"></div>
                              <div className="Btnstar s2"></div>
                              <div className="Btnstar s3"></div>
                              <span>LOGIN</span>
                              <div className="Btnmoon"></div>
                            </button>
                          </div>
                        </div>
                      </AvForm>
                      <p className="mt-3 text-white" id="below-text">
                        Please login using your PRI email ID
                      </p>
                      
                      {/* <p className="mt-3 text-white" id="otp-text" style={{ display: "none", fontSize: "12px" }}>
                        Didn't receive OTP?{" "}
                        <button
                          onClick={() => setShowPopup(true)}
                          style={{
                            color: "#242688",
                            textDecoration: "underline",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "inherit",
                            fontFamily: "inherit",
                          }}
                          onMouseEnter={e => (e.target.style.color = "#242688")}
                          onMouseLeave={e => (e.target.style.color = "#3b82f6")}
                        >
                          Click here
                        </button>
                      </p> */}
                    </TabPane>

                    <TabPane tabId="2">
                      <AvForm
                        className="form-horizontal"
                        onValidSubmit={handleValidSubmit}
                      >
                        <div className="mb-1">
                          <AvField
                            name="Firstname"
                            className="form-control"
                            placeholder="Full Name *"
                            type="text"
                            required
                          />
                        </div>
                        <div className="mb-1">
                          <AvField
                            name="EmployerName"
                            className="form-control"
                            placeholder="Employer Name *"
                            type="text"
                            required
                          />
                        </div>
                        <div className="mb-1">
                          <AvField
                            name="Email"
                            className="form-control"
                            placeholder="Email ID *"
                            type="email"
                            required
                          />
                        </div>
                        <div className="mb-1">
                          <AvField
                            name="storeName"
                            className="form-control"
                            placeholder="Store Name *"
                            type="text"
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <AvField
                            name="customaction"
                            value="Register"
                            className="form-control newgrad"
                            placeholder="action *"
                            type="text"
                            required
                            disabled
                            hidden
                          />
                        </div>
                        <div
                          className="mt-3 d-flex justify-content-evenly"
                          style={{ textAlign: "center" }}
                        >
                          <button
                            style={{
                              backgroundColor: "rgb(255,255,254)",
                              color: "white",
                              borderColor: "white",
                              fontWeight: "bold",
                              marginRight: "5%",
                            }}
                            className="btn btn-primary btn-block"
                            type="submit"
                          >
                            Register
                          </button>
                        </div>
                      </AvForm>
                    </TabPane>
                  </TabContent>
                   {/* {toggleMessage === "Employee"
                    ? "Please enter your name and employee ID."
                    : "Please enter your registered email ID to enter"} */}
                </div>
              </CardBody>
            </Card>
          </center>
        </div>
      </Container>
      {/* <div
        style={{
          cursor: "pointer",
          height: "80px",
          width: "80px",
          position: "absolute",
          top: "85%",
          right: "10%",
        }}
      >
        <img width="100px" src="https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/apple%20virtual%20platform%2FHELP%20Button.png?alt=media" onClick={()=>{onhelpOpenRC(!helprc)}} />
        
      </div> */}
    </React.Fragment>
  )
}

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func,
}

const mapStateToProps = state => {
  const { error, mssg, loading } = state.Login
  return { error, mssg, loading }
}

export default withRouter(
  connect(mapStateToProps, { 
    loginUser, 
    apiError, 
    socialLogin,
    clearLoginMessage 
  })(Login)
)